export function checkReadOnly() {
    let isReadOnly = null;
    const trueValues = ["true", "1"]
    const params = new URLSearchParams(document.location.search.toLowerCase());
    const readOnly = params.get("readonly");
    if (readOnly && trueValues.includes(readOnly.toLowerCase())) {
        isReadOnly = true
    } else {
        isReadOnly = false
    }
    return isReadOnly;
}